import './SidePanel.css';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class SidePanel extends Component {
  static propTypes = {
    from: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    children: PropTypes.node,
    width: PropTypes.string,
  };

  render() {
    const fromSideClass =
      this.props.from === 'right' ? 'from-right' : 'from-left';
    const { width, isOpen, children } = this.props;
    const styles = width
      ? {
          maxWidth: width,
          marginRight: isOpen ? '0' : Number.parseInt(width) * -1,
        }
      : {};

    return (
      <section
        style={styles}
        className={classNames('sidepanel', fromSideClass, {
          'is-open': isOpen,
        })}
      >
        {children}
      </section>
    );
  }
}

export default SidePanel;
